import { forwardRef } from 'react';
import MuiTextField, {
  TextFieldProps as MuiTextFieldProps,
  TextFieldPropsColorOverrides,
  TextFieldPropsSizeOverrides,
} from '@mui/material/TextField';
import { OverridableStringUnion } from '@mui/types';

declare module '@mui/material/TextField' {
  interface TextFieldPropsColorOverrides {
    internal: true;
  }
  interface TextFieldPropsSizeOverrides {
    xs: true;
    date: true;
    large: true;
  }
}

export type TextFieldProps = MuiTextFieldProps & {
  color?: OverridableStringUnion<
    'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'internal',
    TextFieldPropsColorOverrides
  >;
  size?: OverridableStringUnion<'xs' | 'date' | 'small' | 'medium' | 'large', TextFieldPropsSizeOverrides>;
};

const TextField = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
  return <MuiTextField ref={ref} {...props} />;
});

TextField.defaultProps = {
  color: 'primary',
  variant: 'outlined',
};

TextField.displayName = 'TextField';

export default TextField;
